var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiLgAssignment = function SvgAiLgAssignment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 61 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-lg-assignment_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.75,
    height: 14,
    x: 22.25,
    y: 1,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 4,
    x: 15,
    y: 17,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 15,
    y: 24,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M19 14h15v12H19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M38.565 17.585c.176 0 .335.11.402.279a.46.46 0 0 1-.094.491l-5.314 5.513a.42.42 0 0 1-.474.098.45.45 0 0 1-.269-.417v-5.513c0-.249.195-.45.435-.45zm-4.88 4.875 3.83-3.973h-3.83zM37.028 7.968a1.39 1.39 0 0 0 0-1.913l-.729-.757a1.27 1.27 0 0 0-1.844 0l-1.652 1.713 2.574 2.67zm-1.344 2.67a.424.424 0 0 1-.614 0L31.88 7.33a.463.463 0 0 1 0-.638l1.959-2.031a2.12 2.12 0 0 1 3.074 0l.729.756c.849.88.849 2.308 0 3.189z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M35.684 10c.17.176.17.462 0 .638l-6.377 6.615a.43.43 0 0 1-.2.118l-4.25 1.12a.43.43 0 0 1-.415-.117.46.46 0 0 1-.115-.43l1.062-4.427a.46.46 0 0 1 .115-.21l6.377-6.615a.424.424 0 0 1 .615 0zm-9.48 3.856-.858 3.574 3.431-.903 5.985-6.208-2.574-2.67z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M26.875 5.458c.24 0 .434.202.434.45 0 .25-.194.452-.434.452H19.87v16.738H33.25c.24 0 .435.202.435.45 0 .25-.195.452-.435.452H19.435a.443.443 0 0 1-.435-.451V5.909c0-.25.195-.451.435-.451zM38.13 18.036v-4.41c0-.249.195-.45.435-.45s.435.201.435.45v4.41c0 .25-.195.451-.435.451a.443.443 0 0 1-.435-.45"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m50.5 6 .99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-lg-assignment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 0h30v30H15z"
  })))));
};
export { SvgAiLgAssignment as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-lg-assignment-f7373220a0ad66718c5b603b2914d12c.svg";